var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloudEmptyShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 557,
    height: 353,
    viewBox: "0 0 557 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3768_2951)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.161 5C384.411 5 423.195 34.5819 427.214 72.2874C437.653 68.8523 449.058 66.9613 461.005 66.9613C510.93 66.9613 551.402 99.9863 551.402 140.725C551.402 167.167 534.351 190.36 508.732 203.381C514.638 213.186 517.955 224.217 517.955 235.88C517.955 276.618 477.483 309.643 427.558 309.643C411.045 309.643 395.566 306.03 382.243 299.72C369.529 327.901 336.334 348 297.386 348C263.594 348 234.133 332.871 218.621 310.46C202.835 321.45 182.358 328.084 159.982 328.084C110.057 328.084 69.5844 295.059 69.5844 254.32C69.5844 253.272 69.6112 252.228 69.6643 251.191C32.482 242.042 5.40234 213.88 5.40234 180.557C5.40234 139.819 45.8746 106.794 95.7997 106.794C96.7563 106.794 97.7095 106.806 98.659 106.83C96.7925 100.925 95.7997 94.7333 95.7997 88.3527C95.7997 47.6143 136.272 14.5893 186.197 14.5893C215.366 14.5893 241.307 25.8621 257.837 43.36C273.193 20.4994 302.958 5 337.161 5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3768_2951",
    x: 0.402344,
    y: 0,
    width: 556,
    height: 353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3768_2951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3768_2951",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudEmptyShadow);
export default __webpack_public_path__ + "static/media/cloud-empty-shadow.8ae86b6794e3d5c7d64fc76a7327dd47.svg";
export { ForwardRef as ReactComponent };